<template>
  <div class="process">
    <p class="text-h6">参加手順</p>
    <v-card class="mb-8 how-to-join-card"
      flat
      outlined
    >
      <div v-html="howToJoin" class="how-to-join-text pa-4" />
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'process_participation',
  data () {
    return {
      tabs: null,
      howToJoin: null
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async mounted () {
    // 参加手順
    this.howToJoin = this.campaign.how_to_join
  }
}
</script>

<style scoped lang="scss">
.how-to-join-card {
  display: flex !important;
  flex-direction: column;
}
.how-to-join-text {
  flex-grow: 1;
  overflow: auto;
  font-size: 0.9rem;
}
</style>
